import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, Grid, Typography } from '@material-ui/core'

import {
  BaseLeaflet,
  DashboardChartPaper,
  DashboardNumberCard,
  DashboardTable,
  DonutChart,
} from 'components'

import helpers from 'helpers'

import theme from 'theme'
import useStyles from './styles'
import constants from 'constants/index'

const SharedData = ({ isLoading = false, sharedData = {} }) => {
  const {
    SHARED_DATA_COUNTRIES_TABLE,
    SHARED_DATA_SOFTWARES_TABLE,
    SHARED_DATA_TABLE,
  } = constants.dataIntelligence
  const { SHARE_TYPE_IDS } = constants.dataCollected

  const classes = useStyles()

  const typeValues = SHARE_TYPE_IDS.map(
    (id) =>
      sharedData?.shareTypes?.find((item) => item?.id === id)?.quantity || 0,
  )

  const markers = helpers.leaflet.defineMarkers(sharedData?.countries)

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Typography variant="h5" color="primary">
        Compartilhamento e transferência de dados
      </Typography>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          lg={6}
          className={clsx(classes.smallGridItem, {
            [classes.smallIsLoading]: isLoading,
          })}
        >
          <DashboardTable
            emptyMessage="Nenhum compartilhamento foi encontrado."
            rows={sharedData?.shareProcesses}
            columns={SHARED_DATA_TABLE}
            isLoading={isLoading}
            hasPaper
            tableHeadProps={{ className: classes.tableHead }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={3}
          className={clsx(classes.smallGridItem, {
            [classes.smallIsLoading]: isLoading,
          })}
        >
          <DashboardNumberCard
            label="Nacionais"
            value={sharedData?.nationalCount}
            isLoading={isLoading}
            tooltipProps={{
              title:
                'Quantidade de processos que contém transferência nacional',
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={3}
          className={clsx(classes.smallGridItem, {
            [classes.smallIsLoading]: isLoading,
          })}
        >
          <DashboardNumberCard
            label="Internacionais"
            value={sharedData?.internationalCount}
            isLoading={isLoading}
            tooltipProps={{
              title:
                'Quantidade de processos que contém transferência internacional',
            }}
          />
        </Grid>
        <Grid item xs={12} lg={8} className={classes.fixedGridItem}>
          <DashboardChartPaper
            title="Transferência internacional"
            subtitle="Acompanhe os locais para onde os dados são compartilhados"
            noMaxHeight
            isLoading={isLoading}
          >
            <BaseLeaflet markers={markers} />
          </DashboardChartPaper>
        </Grid>
        <Grid item xs={12} lg={4} className={classes.fixedGridItem}>
          <DashboardChartPaper
            title="Tipo de compartilhamento"
            subtitle="Dados compartilhados internamente e externamente"
            isLoading={isLoading}
            noMaxHeight
          >
            <DonutChart
              legendShow
              names={['Interno', 'Externo', 'Ambos']}
              values={typeValues}
              title="Tempo de armazenamento"
              colors={[
                theme.palette.dashboard.chart.primary.approved,
                theme.palette.dashboard.chart.primary.pending,
                theme.palette.dashboard.chart.primary.inProgress,
              ]}
              showName={false}
            />
          </DashboardChartPaper>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Países de destino"
            subtitle="Acompanhe os países para onde os dados são compartilhados"
            noMaxHeight
          >
            <DashboardTable
              emptyMessage="Nenhum país de destino encontrado."
              rows={sharedData?.countries}
              columns={SHARED_DATA_COUNTRIES_TABLE}
              isLoading={isLoading}
            />
          </DashboardChartPaper>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Softwares compartilhados"
            subtitle="Acompanhe os softwares que são compartilhados"
            noMaxHeight
          >
            <DashboardTable
              emptyMessage="Nenhum software compartilhado encontrado."
              rows={sharedData?.sharedSoftwares}
              columns={SHARED_DATA_SOFTWARES_TABLE}
              isLoading={isLoading}
            />
          </DashboardChartPaper>
        </Grid>
      </Grid>
    </Box>
  )
}

SharedData.propTypes = {
  isLoading: PropTypes.bool,
  sharedData: PropTypes.object,
}

export default SharedData
